import React, { useEffect } from "react";
import s from "./Home.module.scss";
import Header from "../../components/Header/Header";
import Filters from "../../components/Filters/Filters";
import NewCars from "../../components/NewCars/NewCars";
import Catalogue from "../../components/Catalogue/Catalogue";
import Footer from "../../components/Footer/Footer";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import { useDispatch, useSelector } from "react-redux";
import {
  getBrandList,
  getCarList,
  getCarsCategories,
  getLocation,
  getModelList,
  getMyCars,
  getNewCars,
} from "../../redux/carSlice";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";

const Home = () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const cars = useSelector((state) => state.cars.cars);
  const passengerСars =
    Array.isArray(cars) && cars?.filter((it) => it.vehicle_type?.id === 1);
  const commercialСars =
    Array.isArray(cars) && cars?.filter((it) => it.vehicle_type?.id === 2);
  const tools =
    Array.isArray(cars) && cars?.filter((it) => it.vehicle_type?.id === 4);
  const moto =
    Array.isArray(cars) && cars?.filter((it) => it.vehicle_type?.id === 3);

  const special =
    Array.isArray(cars) && cars?.filter((it) => it.vehicle_type?.id === 5);

  useEffect(() => {
    dispatch(getCarList());
    dispatch(getNewCars());
    dispatch(getLocation());
    dispatch(getCarsCategories());
    dispatch(getMyCars());
    dispatch(getBrandList());
    dispatch(getModelList());
  }, [dispatch]);

  return (
    <div>
      {width > 800 ? (
        <div className={s.top}>
          <img src='/images/topblack.webp' className={s.topImg} alt='' />
        </div>
      ) : null}
      <div className={s.home}>
        {width > 800 ? (
          <div className={s.left}>
            <img src='/images/left.webp' className={s.leftImg} alt='' />
          </div>
        ) : null}
        <div className={s.main}>
          <div className={s.body}>
            {width > 1200 ? <Header /> : <MobileHeader />}
            {width > 1200 ? <Filters /> : null}
            <section className={s.main_content}>
              <div className={s.content}>
                <div className={s.add}>
                  <img
                    src='/images/top-electro.webp'
                    className={s.top2}
                    alt=''
                  />
                </div>
                <NewCars />
                <Catalogue
                  title={"Легковые авто"}
                  cars={passengerСars}
                  categoryId={1}
                />
                <Catalogue
                  title={"Коммерческие авто"}
                  cars={commercialСars}
                  categoryId={2}
                />
                <Catalogue title={"Мото"} cars={moto} categoryId={3} />
                <Catalogue
                  title={"Спецтехника"}
                  cars={special}
                  categoryId={5}
                />
                <Catalogue title={"Запчасти"} cars={tools} categoryId={4} />
              </div>
              {width > 1200 ? (
                <div className={s.sidebar_add}>
                  Реклама
                  {/* <img src='/images/rightsideadd.jpeg' className={s.sideAdd} /> */}
                </div>
              ) : null}
            </section>
          </div>
        </div>
        {width > 800 ? (
          <div className={s.right}>
            <img src={"/images/right.webp"} className={s.rightImg} />
          </div>
        ) : null}
      </div>
      <div className={s.footer}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default Home;
